import { compiledClientConfig } from "config";
import { getI18nTextIfExists } from "utils/i18n";

import { EntitleError } from "./entitleError";

interface ICommonErrorParams {
  location?: never;
  message: string;
  parentObject?: never;
  requestedProperty?: never;
  title?: string;
}

interface IIsNullErrorParams {
  location?: string;
  message?: never;
  parentObject?: {
    name: string;
    value: unknown;
  };
  requestedProperty?: number | string | symbol;
  title?: never;
}

type TIsNullErrorParams = ICommonErrorParams | IIsNullErrorParams;

const isCommonParams = (params: TIsNullErrorParams): params is ICommonErrorParams =>
  typeof params === "object" && "message" in params;

export class IsNullError extends EntitleError {
  constructor(message?: string, title?: string) {
    super(message, title || undefined);
    this.name = "IsNullError";
  }

  static from(params: TIsNullErrorParams) {
    if (isCommonParams(params)) {
      return new IsNullError(params.message, params.title);
    }
    if (compiledClientConfig.appEnv !== "production") {
      const errorMessageTexts = ["Error: "];
      if (params.location) {
        errorMessageTexts.push(`in: ${params.location}`);
      }
      if (params.parentObject) {
        errorMessageTexts.push(`of: ${params.parentObject.name}`);
        try {
          errorMessageTexts.push(`with value: ${JSON.stringify(params.parentObject.value, null, 2)}`);
        } catch {
          errorMessageTexts.push("with complex value");
        }
      }
      if (params.requestedProperty) {
        errorMessageTexts.push(`property: ${params.requestedProperty.toString()}`);
      }
      return new IsNullError(errorMessageTexts.join("\n"), "Property is null error");
    } else {
      return new IsNullError(
        getI18nTextIfExists("errors.isNull.message") || "",
        getI18nTextIfExists("errors.isNull.title") || undefined,
      );
    }
  }
}
